module.exports = __webpack_public_path__ + "img/empanadas.70f67fae.jpeg";